import {getEventTitle} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {EventText} from '../../../../../commons/components/event-text'
import {isMobile} from '../../../../../commons/selectors/environment'
import {useMembersPageSelector} from '../../hooks/runtime'
import {Date} from './date'
import s from './event-summary.scss'
import {EventSummaryProps} from './interfaces'
import {MobileDate} from './mobile-date'

export const EventSummary = ({event}: EventSummaryProps) => {
  const mobile = useMembersPageSelector(isMobile)

  return (
    <div className={classNames(s.root, {[s.mobile]: mobile})} data-hook={DH.EVENT_SUMMARY}>
      {mobile ? <MobileDate event={event} /> : <Date event={event} />}
      <div className={s.name}>
        <EventText dataHook={DH.EVENT_TITLE}>{getEventTitle(event.event)}</EventText>
      </div>
    </div>
  )
}
